<template>
    <a href="javascript:void(0)" class="text-muted like" @click="toggleFavorite">
<!--        ti-flag-alt-2-->
        <i class="ti ti-flag me-1 " :class="{ 'text-warning' : question?.favorite !== null }"></i>
<!--        {{ question?.favorite !== null ? 'Unfavorite' : 'Favorite' }}-->
    </a>
</template>

<script>
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    props: {
        question: {
            type: Object,
            required: true
        },
    },
    data() {
    },
    methods: {
        toggleFavorite() {
            // const action = (this.question?.favorite !== null) ? 'remove from' : 'add to';
            // const id = toast.info(`Trying to ${action} favorites...`, {
            //     icon: "fa-solid fa-cloud-arrow-up"
            // });

            const url = (this.question?.favorite !== null) ? `question_favorites/${this.question?.favorite?.id}` : 'question_favorites';
            const method = (this.question?.favorite !== null) ? 'delete' : 'post';
            const data = (this.question?.favorite !== null) ? {
                'subscribe_id': this.$route?.params?.subscribe_id
            } : {
                'question_id': this.question.id,
                'subscribe_id': this.$route?.params?.subscribe_id
            };

            axios({
                method: method,
                url: url,
                data: data
            }).then(response => {
                // toast.dismiss(id);
                toast.success(response.data.message, {
                    timeout: 3000,
                    icon: "fa-solid fa-circle-check"
                });

                this.$emit('update:item',response.data);

                // this.question?.favorite = this.question.data?.data ?? null;
            }).catch(error => {
                // toast.dismiss(id);
                if (error.response) {
                    // this.validationErrors = error.response.data.errors;
                    // this.error_message = error.response.data.message;
                    toast.error(error.response.data.message, {
                        timeout: 3000,
                        icon: "fa-solid fa-circle-exclamation"
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
/* Add any styles you need for your component here */
</style>
